<div class="space-y-6">
  <h2 class="mb-6 text-center text-3xl font-bold text-greyscale-900">
    {{ 'register.requestToJoin' | transloco:{ company: targetCompany.name } }}
  </h2>

  <!-- Info message -->
  <div class="rounded-md bg-validation-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <i class="pi pi-check-circle text-validation-500"></i>
      </div>
      <div class="ml-3">
        <p class="text-sm text-validation-700" [innerHTML]="'register.requestAccessMessage' | transloco:{ company: targetCompany.name }">
        </p>
      </div>
    </div>
  </div>

  <form [formGroup]="joinForm" (ngSubmit)="onSubmit()" class="space-y-6">
    
    <!-- Message to administrator -->
    <div>
      <label for="messageToAdmin" class="mb-1 block text-sm font-medium text-greyscale-700">
        {{ 'register.messageToAdmin' | transloco }} 
        <span class="text-greyscale-500">{{ 'register.optional' | transloco }}</span>
      </label>
      <textarea
        id="messageToAdmin"
        formControlName="message"
        [placeholder]="'register.tellAdminsWhy' | transloco"
        rows="4"
        class="w-full resize-none rounded-md border border-greyscale-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
        [class.border-error-500]="
          joinForm.get('message')?.invalid &&
          joinForm.get('message')?.touched
        "
      ></textarea>
      

      <!-- Validation message -->
      @if (joinForm.get('message')?.errors && joinForm.get('message')?.touched) {
        <div class="mt-1">
          @if (joinForm.get('message')?.errors?.['maxlength']) {
            <small class="text-error-600">
              {{ 'register.messageTooLong' | transloco }}
            </small>
          }
        </div>
      }
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-3 pt-4 items-center">
      <a
        class="py-2 text-sm font-medium text-primary-600 no-underline hover:text-primary-500 flex items-center"
        routerLink="/auth/login"
      >
        <i class="pi pi-arrow-left mr-2"></i>
        {{ 'register.returnToLogin' | transloco }}
      </a>
      
      <button
        type="submit"
        [disabled]="isLoading || !joinForm.valid"
        class="flex flex-1 items-center justify-center rounded-md bg-primary-600 px-6 py-2 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        @if (isLoading) {
          <i class="pi pi-spinner pi-spin mr-2"></i>
        } @else {
          <i class="pi pi-user-plus mr-2"></i>
        }
        {{ isLoading ? ('register.sendingRequest' | transloco) : ('register.sendRequest' | transloco) }}
      </button>
    </div>

  </form>
</div>